import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import auditLogService from '../../../services/auditLogService';

const ExportButton = ({ filters }) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const { data, error } = await auditLogService?.exportAuditLogs(filters);
      
      if (error) {
        console.error('Export error:', error);
        alert('Error al exportar los registros');
        return;
      }

      // Create download link
      const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link?.setAttribute('href', url);
      link?.setAttribute('download', `audit_logs_${new Date()?.toISOString()?.split('T')?.[0]}.csv`);
      link.style.visibility = 'hidden';
      
      document.body?.appendChild(link);
      link?.click();
      document.body?.removeChild(link);
    } catch (error) {
      console.error('Export error:', error);
      alert('Error al exportar los registros');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={isExporting}
      className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-smooth shadow-sm hover:shadow-md"
    >
      <Icon name={isExporting ? 'Loader2' : 'Download'} size={20} className={isExporting ? 'animate-spin' : ''} />
      <span className="font-medium">
        {isExporting ? 'Exportando...' : 'Exportar CSV'}
      </span>
    </button>
  );
};

export default ExportButton;